import React from 'react';

const HighlightedText = ({ text, highlight }) => {
  if (!highlight || !highlight.trim()) return <>{text}</>;
  
  // Escape regex chars to prevent errors
  const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
  const parts = text.split(regex);
  
  return (
    <>
      {parts.map((part, i) => 
        regex.test(part) ? (
          <span key={i} className="bg-yellow-200 text-yellow-900 font-bold rounded-sm px-[2px]">{part}</span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
};

export default HighlightedText;
